// frontend/src/pages/learning/AssignmentTopics.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './styles/AssignmentTopics.css';
import topics from './AssignmentTopicList';

const AssignmentTopics = () => {
    const [index, setIndex] = useState(0);

    return (
        <div className="my-2 p-2 border-t border-blue-400">
            <h1 className='text-m lg:text-lg text-yellow-200'>Assignment Topics To Be Selected</h1>
            <div className="topic-grid">
                {topics.reduce((acc, topic, index) => {
                    if (index === 0 || topic.topictype !== topics[index - 1].topictype) {
                        acc.push(
                            <div key={topic.topictype} className="topic-type text-sm lg:text-m text-teal-200">
                                Select your {topic.topictype}: 
                            </div>
                        );
                    }

                    acc.push(
                        <div key={index} className="topic-item">
                            <Link
                                to={{
                                    pathname: topic.landingPageUrl,
                                    state: {
                                        owner: topic.owner,
                                        code: topic.code,
                                        title: topic.title,
                                        topictype: topic.topictype,
                                        desc: topic.desc,
                                    }
                                }}
                                className="topic-link"
                            >
                                <div className="topic-item">
                                    <span className="text-xs lg:text-sm px-4 text-gray-100 hover:text-white">{topic.sn}. {topic.title}</span>
                                </div>
                            </Link>
                        </div>
                    );
                    return acc;
                }, [])}
            </div>
        </div>
    );
};

export default AssignmentTopics;
